import { render, staticRenderFns } from "./SelectedFlightListHeaderSlots.vue?vue&type=template&id=6b5f674c"
import script from "./SelectedFlightListHeaderSlots.vue?vue&type=script&lang=js"
export * from "./SelectedFlightListHeaderSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports